<template>
  <van-popup
    class="step-price-popup"
    :value="detailsVisible"
    position="bottom"
    closeable
    @click-close-icon="close"
    @click-overlay="close"
  >
    <div class="popup-wrapper">
      <div class="popup-title">阶梯价格设定</div>
      <div class="popup-body">
        <hi-card v-for="(item, index) in priceList" :key="item.id || index" :row-index="index + 1">
          <div class="row-item">
            <span class="label">阶梯:</span>
            <span class="value">{{ item.level }}</span>
          </div>
          <div class="row-item">
            <span class="label">大于等于数量:</span>
            <span class="value">{{ item.rangeStart }}</span>
          </div>
          <div class="row-item">
            <span class="label">小于等于数量:</span>
            <span class="value">{{ item.rangeEnd }}</span>
          </div>
          <div class="row-item">
            <span class="label">价格:</span>
            <span class="value">{{ item.taxPrice || item.price }}</span>
          </div>
        </hi-card>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { getInfoByLineId } from '@/api/pmCostApplyStepPrice'

export default {
  name: 'LinkagePriceAdjustStepPriceDialog',
  props: {
    detailsVisible: {
      type: Boolean,
      default: false
    },
    lineId: {
      type: [String, Number],
      default: undefined
    }
  },
  data() {
    return {
      priceList: []
    }
  },
  watch: {
    detailsVisible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadData()
        }
      }
    }
  },
  methods: {
    async loadData() {
      if (!this.lineId) {
        this.priceList = []
        return
      }
      const response = await getInfoByLineId(this.lineId)
      this.priceList = (response && response.data) || []
    },
    close() {
      this.$emit('close-details-dialog')
    }
  }
}
</script>

<style lang="scss" scoped>
.step-price-popup {
  height: 90vh;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;
}
.popup-wrapper {
  height: 90vh;
  display: flex;
  flex-direction: column;
  position: relative;
}
.popup-title {
  text-align: center;
  padding: 0 40px;
  height: 46px;
  line-height: 46px;
  font-size: 17px;
  font-weight: 500;
  color: #333;
}
.popup-body {
  flex: 1;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 10px;
  background: #f7f8fa;
}
.row-item {
  display: flex;
  align-items: flex-start;
  padding: 1px 0;
  box-sizing: border-box;
}
.label {
  width: 120px;
  color: #666666;
  flex-shrink: 0;
}
.value {
  flex: 1;
  color: #262626;
  word-break: break-all;
}
.step-price-popup :deep(.van-popup__close-icon) {
  top: 11px;
}
:deep(.custom-card) {
  margin: 10px 5px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
:deep(.row-index) {
  top: 0;
  right: 0;
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1px;
  box-sizing: border-box;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: #409eff;
  color: #fff;
}
</style>
